import { FunctionComponent as F } from "react";
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import { Checkbox, FormControl, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import { IDiscount } from "@protoplan/types";
import IconPopper from "./IconPopper";
import { useSelector } from "react-redux";
import { IState } from "../../../core/store/store";


interface Props
{
  protocolId?: number,
  dosingId?: number,
  listingId?: number,
  toggleDiscountsAsync: (discountIds: number[]) => Promise<any>;
  disabled?: boolean,
}

const Discounts: F<Props> = (props: Props) =>
{
  const discounts = useSelector((state: IState) =>
  {
    if(props.protocolId && props.dosingId)
    {
     return state.protocol.protocols
      .find(p => p.protocolId === props.protocolId)?.dosings
      ?.find(d => d.dosingId === props.dosingId)?.discounts;
    }
    else if(props.listingId)
    {
      return state.listings.listings
       ?.find(l => l.listingId === props.listingId)?.discounts;
    }
    else
    {
      return;
    }
  }) || [];

  const exclusiveDiscounts = discounts.filter(d => !d.compounds);
  const compoundingDiscounts = discounts.filter(d => d.compounds);
  const appliedCompoundingDiscounts = compoundingDiscounts.filter(d => d.applied);
  const appliedExclusiveDiscounts = exclusiveDiscounts.filter(d => d.applied);  // length = 1 or 0
  const appliedDiscounts = appliedCompoundingDiscounts.concat(appliedExclusiveDiscounts);

  const handleRadioChange = async(event: React.ChangeEvent<HTMLInputElement>) =>
  {
    // Deselect any existing non-compounding discount first
    const discountIds = appliedExclusiveDiscounts.map(d => d.discountId);

    if(Number(event.target.value))
      discountIds.push(Number(event.target.value));

    await props.toggleDiscountsAsync(discountIds);
  }

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) =>
  {
    props.toggleDiscountsAsync([Number(event.target.value)]);
  }

  const radio = (discount: IDiscount) => <FormControlLabel
    disabled={props.disabled}
    key={discount.discountId}
    value={discount.discountId}
    slotProps={{ typography: { fontSize: 12 } }}
    control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: 12 } }} />}
    label={discount.title + ": " + discount.desc} />

  const radioNoneValue = 0;
  const radioNoneLabel = "None";
  const radioNone = <FormControlLabel
    disabled={props.disabled}
    key={radioNoneLabel}
    value={radioNoneValue}
    slotProps={{ typography: { fontSize: 12 } }}
    control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: 12 } }} />}
    label={radioNoneLabel}/>

  const checkbox = (discount: IDiscount) => <FormControlLabel
    disabled={props.disabled}
    key={discount.discountId}
    value={discount.discountId}
    label={discount.title + ": " + discount.desc}
    slotProps={{ typography: { fontSize: 12 } }}
    control={<Checkbox
      sx={{ '& .MuiSvgIcon-root': { fontSize: 12 } }}
      checked={compoundingDiscounts.find(d => d.discountId === discount.discountId)?.applied}
      onChange={handleCheckboxChange}
      inputProps={{ 'aria-label': 'controlled' }}/>}/>



  const tooltip =
    <>
      <Typography gutterBottom style={{ fontSize: 12, fontWeight:'bold' }} component="div">
        {props.disabled ? (appliedDiscounts.length ? "Discounts" : "No discounts applied") : "Apply discount"}
      </Typography>
      <FormControl>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          value={appliedExclusiveDiscounts.length ?
            appliedExclusiveDiscounts[0].discountId :
            radioNoneValue}
          onChange={handleRadioChange}
          name="radio-buttons-group">
          {exclusiveDiscounts.length ?
            discounts.filter(d => !d.compounds).map(d => radio(d)).concat(radioNone) :
            <></>}
        </RadioGroup>
      </FormControl>
      <FormControl component='fieldset'>
        {compoundingDiscounts.map(d => checkbox(d))}
      </FormControl>
    </>;


  return(
    <IconPopper
      Content={tooltip}
      Icon={
        <MoneyOffIcon
          fontSize='small'
          sx={{
            height: 17,
            color: appliedDiscounts.length ? 'green' : 'lightGray',
            cursor: props.disabled ? 'default' : 'pointer' }}
          style={{ display: "flex", justifyContent: "center" }}/>}/>);
  };

export default Discounts;
